import React, { useState } from 'react';
import styles from './ContactInfo.module.css';

const ContactInfo = ({ onNext, onPrev }) => {
  const [contactPhone, setContactPhone] = useState('');
  const [contactEmail, setContactEmail] = useState('');

  const initialPrefs = {
    miloMessage: { low: false, mid: false, high: false },
    email: { low: false, mid: false, high: false },
    phone: { low: false, mid: false, high: false },
  };

  const [contactPrefs, setContactPrefs] = useState(initialPrefs);

  const handleToggle = (method, level) => {
    setContactPrefs((prev) => ({
      ...prev,
      [method]: {
        ...prev[method],
        [level]: !prev[method][level],
      },
    }));
  };

  const handleNext = () => {
    // Backend integration logic here
    onNext();
  };

  const levels = ['low', 'mid', 'high'];

  return (
	<div className={styles.container}>
	  <div className={styles.contactSection}>
		<div className={styles.inputGroup}>
		  <label className={styles.label}>Contact Phone</label>
		  <input
			type="tel"
			className={styles.input}
			value={contactPhone}
			onChange={(e) => setContactPhone(e.target.value)}
			placeholder="(123) 456-7890"
		  />
		</div>

		<div className={styles.inputGroup}>
		  <label className={styles.label}>Contact Email</label>
		  <input
			type="email"
			className={styles.input}
			value={contactEmail}
			onChange={(e) => setContactEmail(e.target.value)}
			placeholder="example@milo.com"
		  />
		</div>
	  </div>

	  <div className={styles.prefsContainer}>
		<h3 className={styles.prefTitle}>Contact Preferences</h3>

		<div className={styles.grid}>
		  <div className={styles.gridHeader}></div>
		  {['Low', 'Mid', 'High'].map((level) => (
			<div key={level} className={styles.gridHeader}>
			  {level}
			</div>
		  ))}

		  {['miloMessage', 'email', 'phone'].map((method) => (
			<React.Fragment key={method}>
			  <div className={styles.gridLabel}>
				{method === 'miloMessage' ? 'Milo Message' : method.charAt(0).toUpperCase() + method.slice(1)}
			  </div>
			  {['low', 'mid', 'high'].map((level) => (
				<button
				  key={level}
				  className={`${styles.gridButton} ${
					contactPrefs[method][level] ? styles.active : ''
				  }`}
				  onClick={() => handleToggle(method, level)}
				/>
			  ))}
			</React.Fragment>
		  ))}
		</div>
	  </div>
	</div>

  );
};

export default ContactInfo;
